import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from '@core/providers/http';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FaqsService {
  public params = new HttpParams();

  constructor(private readonly apiService: ApiService) { }

  // listar faqs
  list(params?: any): Observable<any> {
    return this.apiService.get(`/PerguntasFrequentes`, params ? new HttpParams({
      fromObject: params
    }) : this.params,
    ).pipe(
      map(response => response)
    );
  }

  /**
* Cria uma nova FAQ
* @param payload
* @returns Observable<any>
*/
  public store(payload: string, formData: FormData): Observable<any> {
    return this.apiService.post(`/PerguntasFrequentes?payload=${encodeURIComponent(payload)}`, formData);
  }

  // atualizar faq
  update(faq: any): Observable<any> {
    return this.apiService.put(`/PerguntasFrequentes`, faq);
  }

  toggleStatus(id: string): Observable<any> {
    return this.apiService.patch(`/PerguntasFrequentes/${id}`);
  }

  delete(id: string): Observable<any> {
    return this.apiService.delete(`/PerguntasFrequentes/${id}`);
  }
}
